module.exports = __webpack_public_path__ + "media/img/home/product/product4-ee5d05fa656b8937a29a5c2c88fd4822.svg";